export default __webpack_public_path__ + "fonts/angle-right-regular.svg";